/**
 * Colorado geographic regions and their bounding boxes, used by the Advanced
 * Query builder to attach a geographic area to a query.
 *
 * These are real geographic constants (approximate WGS84 bounds), not mock
 * data — they describe fixed places, so they live here rather than in any
 * dataset fixture. Each bbox is { north, south, east, west } in decimal
 * degrees, matching the order the engine data API expects when a bounding box
 * is turned into a query envelope.
 */

export const COLORADO_REGIONS = [
    {
        id: 'statewide',
        name: 'Statewide',
        description: 'All of Colorado',
        bbox: {
            north: 41.003444,
            south: 36.992424,
            east: -102.041524,
            west: -109.060256,
        },
    },
    {
        id: 'front-range',
        name: 'Front Range',
        description: 'Denver metro, Boulder, Fort Collins, Colorado Springs',
        bbox: {
            north: 40.917574,
            south: 38.265427,
            east: -104.63623,
            west: -105.737305,
        },
    },
    {
        id: 'western-slope',
        name: 'Western Slope',
        description: 'Grand Junction, Aspen, Durango, Steamboat Springs',
        bbox: {
            north: 40.917574,
            south: 37.000263,
            east: -106.645507,
            west: -109.060256,
        },
    },
    {
        id: 'denver-metro',
        name: 'Denver Metro',
        description: 'Denver, Aurora, Lakewood, Thornton, Westminster',
        bbox: {
            north: 39.91455,
            south: 39.61491,
            east: -104.600906,
            west: -105.109927,
        },
    },
    {
        id: 'boulder-county',
        name: 'Boulder County',
        description: 'Boulder, Longmont, Lafayette, Louisville',
        bbox: {
            north: 40.25577,
            south: 39.918076,
            east: -105.042725,
            west: -105.644531,
        },
    },
    {
        id: 'colorado-springs',
        name: 'Colorado Springs',
        description: 'Colorado Springs metropolitan area',
        bbox: {
            north: 38.95639,
            south: 38.746741,
            east: -104.760284,
            west: -104.951172,
        },
    },
];

/**
 * Look up a region by id.
 * @param {string} id - Region id (e.g. 'statewide')
 * @returns {Object|null} The matching region, or null if not found.
 */
export function getRegionById(id) {
    return COLORADO_REGIONS.find((region) => region.id === id) || null;
}
